import React, { Component, Fragment, useState } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import moment from 'moment';
import './App.scss';
import { DefaultLayout } from './containers';
import { SearchResult } from './containers';
import ScrollButton from './components/ScrollButton/ScrollButton';
import ModalPromos from './components/ModalPromos/ModalPromos';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {WhatsappSelect} from './components/WhatsappSelect/WhatsappSelect';

localStorage.removeItem("DateUltimoIngreso");
localStorage.removeItem("DateVencimiento");
let DateUltimoIngreso = localStorage.getItem('Vencimiento');
let RightNow = moment();
if (DateUltimoIngreso == undefined || DateUltimoIngreso == null || DateUltimoIngreso.toLowerCase() == "invalid date") {
	DateUltimoIngreso = moment();
} else {
	try {
		DateUltimoIngreso = moment(DateUltimoIngreso, "YYYY-MM-DD[T]HH:mm:ss");
	} catch (e) {
		RightNow.add(-1, "hour");
		DateUltimoIngreso = moment();
	}
	finally {
		localStorage.removeItem('Vencimiento');
	}
}
let OpenModal = false;
if (RightNow >= DateUltimoIngreso) {
	DateUltimoIngreso = RightNow.add(1, "hour");
	OpenModal = true;
} else {
	OpenModal = false;
}
localStorage.setItem('Vencimiento', DateUltimoIngreso.format('YYYY-MM-DD[T]HH:mm:ss'));

class App extends Component {
	constructor() {
		super();
		this.state = {
			Configuracion: {
				Sitio: {
					Nombre: "SIGE ECOMMERCE",
				},
			}
		}
	}

	render() {
		return (
			<Fragment>
				<Router>
					<Switch>
						<Route path="/" name="Home" component={() => <DefaultLayout Configuracion={this.state.Configuracion} />} />
					</Switch>
				</Router>
				<ScrollButton scrollStepInPx="50" delayInMs="16.66" />
					{/* <ModalPromos OpenModal={OpenModal || true} /> */}
				<WhatsappSelect />
			</Fragment>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js